import { useQuery } from '@tanstack/react-query';

import { request } from '@paid-ui/utils/axios';

interface BusinessACNCheckParams {
  acn: string;
}
type BusinessACNCheckResponse = { data: boolean } | null;

export const useBusinessACNCheck = (params: BusinessACNCheckParams) => {
  const { acn } = params;

  return useQuery({
    retry: false,
    enabled: false,
    queryKey: ['BusinessACNCheck', acn],
    queryFn: async ({ signal }) => {
      const { data } = await request.get<BusinessACNCheckResponse>('/business/acn-check', {
        signal,
        params: {
          acn: acn.trim(),
        },
      });
      return data?.data;
    },
  });
};
